// extracted by mini-css-extract-plugin
export default {"label":"textarea_label__fy5cz","target":"textarea_target__5Pzzw","targetError":"textarea_targetError__FB6uT","errorIcon":"textarea_errorIcon__vnlE-","error":"textarea_error__xEJTK"};